import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DeliveryNotePreferredWording } from '@work4all/components/lib/components/entity-picker/delivery-note-preferred-wording-picker/DeliveryNotePreferredWordingPicker';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { useUser } from '@work4all/data';

import { LanguageResource } from '@work4all/utils/lib/i18n/LanguageResource.enum';

import { useLanguageManager } from '../../../../providers/LanguageManagerProvider';
import { DeliveryNotePreferredWordingPickerField } from '../../../entity-picker/DeliveryNotePreferredWordingPickerField';

export const Firm = () => {
  const { t } = useTranslation();
  const { addResource, removeResource, resources } = useLanguageManager();
  const user = useUser();

  const value = useMemo(() => {
    if (resources.includes(LanguageResource.ServiceProvider)) {
      return DeliveryNotePreferredWording.SERVICE_CONFIRMATION;
    }

    if (resources.includes(LanguageResource.ServiceProviderAndDeliveryNote)) {
      return DeliveryNotePreferredWording.SERVICE_CONFIRMATION_AND_DELIVERY_NOTE;
    }

    return DeliveryNotePreferredWording.DELIVERY_NOTE;
  }, [resources]);

  return (
    <Box padding="1rem">
      <Divider title={t('LANGUAGE_MANAGER.DELIVERY_NOTES.TITLE')} />

      <Typography marginY="1rem">
        {t('LANGUAGE_MANAGER.DELIVERY_NOTES.CAPTION')}
      </Typography>

      <DeliveryNotePreferredWordingPickerField
        disabled={!user.isMaster}
        value={value}
        onChange={(value) => {
          if (value === DeliveryNotePreferredWording.DELIVERY_NOTE) {
            const languageResources = Object.values(LanguageResource);
            const currentLanguageResource = resources.find((resource) =>
              languageResources.includes(resource)
            );

            removeResource(currentLanguageResource);
            return;
          }

          switch (value) {
            case DeliveryNotePreferredWording.SERVICE_CONFIRMATION:
              addResource(LanguageResource.ServiceProvider);
              break;

            case DeliveryNotePreferredWording.SERVICE_CONFIRMATION_AND_DELIVERY_NOTE:
              addResource(LanguageResource.ServiceProviderAndDeliveryNote);
              break;
          }
        }}
      />
    </Box>
  );
};
